export default __webpack_public_path__ + "static/media/NetMeeting@32.ff836205.svg";